import React, { Component } from 'react';
import PropTypes from "prop-types";
import { Modal, Button, TextArea, Form } from "@cgn/framework-ui-components/v1";
import { StarIcon } from "@cgn/framework-ui-components/icons";
import classnames from 'classnames';

export default class Voto extends Component {

  static propTypes = {
    idPratica: PropTypes.number,
    onClose: PropTypes.func,
    onVota: PropTypes.func,
    show: PropTypes.bool
  }

  state = {
    votoHovered: null,
    voto: null,
    commento: ""
  }

  UNSAFE_componentWillReceiveProps(next) {
    if (!next.show) {
      this.setState({ voto: null, commento: "" });
    }
  }

  assegnaVoto = v => {
    this.setState({ voto: v });
  }

  render() {
    return (<Modal show={this.props.show} onClose={this.props.onClose} className="support__externalMenuModaleFeedback">
      <Modal.Header>
        <strong>Lascia il tuo feedback</strong>
      </Modal.Header>
      <Modal.Body>
        <div className="voto__containerStars">
          {[1, 2, 3, 4, 5].map(x => {
            var classes = classnames("votazione__star",
              { "votazione__star--hovered": x <= this.state.votoHovered },
              { "votazione__star--selected": x <= this.state.voto });
            return (<StarIcon key={x} className={classes} onClick={() => this.assegnaVoto(x)}
              onMouseEnter={() => this.setState({ votoHovered: x })}
              onMouseLeave={() => this.setState({ votoHovered: null })} />);
          })}
        </div>
        <div className="voto__containerFeedback">
          <Form onChange={x => this.setState(x)} stato={this.state} ref={r => this.form = r}>
            <TextArea title="In cosa possiamo migliorare?" name="commento" validations={[
              { rule: 'maxLength', maxLength: 512, message: 'Il testo del tuo commento supera la lunghezza massima' }
            ]} />
          </Form>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={this.props.onClose}>Annulla</Button>
        <Button primary disabled={!this.state.voto || (this.form && !this.form.isValid)}
          onClick={() => this.props.onVota(this.props.idPratica, this.state.voto, this.state.commento)}
        >Invia e chiudi</Button>
      </Modal.Footer>
    </Modal>);
  }
}